export enum FeatureUsageOrigin {
  PortalOverview = 'Portal_Overview',
  PortalMySessions = 'Portal_MySessions',
  PortalServicesOverview = 'Portal_ServicesOverview',
  PortalAttendantConsole = 'Portal_AttendantConsole',
  PortalHeaderBar = 'Portal_HeaderBar',
  AssistantOutbound = 'Assistant_Outbound',
  Unknown = 'Unknown',
}
